import React from 'react';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import { Translate } from 'react-localize-redux';
import { withRouter } from 'react-router';
import { isNullOrUndefined, isRepiWeb } from '../../store/storeFunctions';
import MainHeader from './mainHeader';

import './headersCommon.scss'

class NewsHeader extends React.Component {

    render() {
        const isOnNews = this.endsWith(this.props.location.pathname, '/news');
        const isOnNotifications = this.endsWith(this.props.location.pathname, '/news-notifications');
        return (
            <>
                <MainHeader label="News.SectionName" {...this.props} />
                { !this.props.isMobile && <div className={classnames('tabs tabs-subheader shadowed', {'tinted' :this.props.tinted })}>
                    <ul style={{ border: "none" }}>
                        {!isRepiWeb() && <li className={`tab-link ${isOnNews ? 'is-active' : ''}`}>
                            <NavLink to={{ pathname: '/news', state: this.props.location.state }}>
                                <Translate id='News.NewsSubsection' />
                            </NavLink>
                            <div className="search-progress-short" style={{ display: isOnNews ? "" : "none" }}></div>
                        </li>}
                        <li className={`tab-link ${isOnNotifications ? 'is-active' : ''}`}>
                            <NavLink to={{ pathname: '/news-notifications', state: this.props.location.state }}>
                                <Translate id='News.NotificationsSubsection' />
                            </NavLink>
                            <div className="search-progress-short" style={{ display: isOnNotifications ? "" : "none" }}></div>
                        </li>
                    </ul>
                </div> }
            </>
        )}

    endsWith = (str, suffix) => isNullOrUndefined(str) || isNullOrUndefined(suffix) ? false : str.lastIndexOf(suffix, str.length - suffix.length) === str.length - suffix.length;
}

export default withRouter(NewsHeader);